<template>
  <div class="box-block">
    <div v-if="isLoaded">
      <ValidationObserver ref="observer">
        <form>
          <div class="row">
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label for="firstname">{{ $t('form.firstname') }}</label>
                <input
                  v-model="firstname"
                  type="text"
                  class="form-control"
                  id="firstname"
                  :placeholder="$t('form.firstname')"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label for="lastname">{{ $t('form.lastname') }}</label>
                <input
                  v-model="lastname"
                  type="text"
                  class="form-control"
                  id="lastname"
                  :placeholder="$t('form.lastname')"
                />
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-group">
                <validation-provider
                  name="country"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="country"
                    >{{ $t('form.country')
                    }}<sup class="text-danger">*</sup></label
                  >
                  <select
                    class="form-control p-0 pl-2"
                    v-model="country"
                    id="country"
                    :placeholder="$t('form.country')"
                    :class="{ 'is-invalid': errors.length }"
                    @change="validationObeserverValidate"
                  >
                    <option></option>
                    <option
                      v-for="item in countries"
                      :value="{ name: item.name, id: item.id }"
                      :key="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <validation-provider
                  name="email"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <label for="company-email"
                    >{{ $t('form.email') }}
                    <sup class="text-danger">*</sup></label
                  >
                  <input
                    v-model="email"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    id="company-email"
                    :placeholder="$t('form.email')"
                  />
                  <span v-cloak class="text-danger small">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <validation-provider
                  name="name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="name"
                    >{{ $t('form.companyName') }}
                    <sup class="text-danger">*</sup></label
                  >
                  <input
                    v-model="name"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    id="name"
                    :placeholder="$t('form.companyName')"
                    :readonly="country === 'France'"
                  />
                </validation-provider>
              </div>
            </div>
            <!-- <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider
                  name="trade-name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="trade-name"
                    >{{$t('form.tradeName')}} <sup class="text-danger">*</sup></label
                  >
                  <input
                    v-model="trade"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    id="trade-name"
                    :placeholder="$t('form.tradeName')"
                  />
                </validation-provider>
              </div>
            </div> -->
            <div class="col-12 col-md-3">
              <div class="form-group">
                <validation-provider
                  name="siret"
                  rules="required_if:country,France"
                  v-slot="{ errors }"
                  ref="mysiret"
                >
                  <label for="siret"
                    >{{ $t('form.siretNumber')
                    }}<sup v-if="country == 'France'" class="text-danger"
                      >*</sup
                    ></label
                  >
                  <input
                    v-model="siret"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    id="siret"
                    :placeholder="$t('form.siretNumber')"
                    v-mask="'##############'"
                    @blur.prevent.stop="handleCompanySIRET($event)"
                    maxlength="14"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-lg-9">
              <div class="form-group">
                <label for="legal">{{ $t('form.codeNaf') }}</label>
                <treeselect
                  :maxHeight="200"
                  v-model="nafCode"
                  :multiple="false"
                  :options="options"
                  :placeholder="$t('form.codeNaf')"
                  @select="setCodeNAf"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider
                  name="phone"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="company-phone"
                    >{{ $t('form.phone') }}
                    <sup class="text-danger">*</sup></label
                  >
                  <input
                    v-model="phone"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    id="company-phone"
                    :placeholder="$t('form.phone')"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-group">
                <label for="vat">{{ $t('form.tva') }}</label>
                <input
                  v-model="vat"
                  type="text"
                  class="form-control"
                  id="vat"
                  :placeholder="$t('form.tva')"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider
                  name="legal"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="legal"
                    >{{ $t('form.legalForm') }}
                    <sup class="text-danger">*</sup></label
                  >
                  <input
                    v-model="legalForm"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    id="legal"
                    :placeholder="$t('form.legalForm')"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-lg-5">
              <div class="form-group">
                <validation-provider
                  name="address"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="company-address"
                    >{{ $t('form.address') }}
                    <sup class="text-danger">*</sup></label
                  >
                  <input
                    v-model="address"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    id="company-address"
                    :placeholder="$t('form.address')"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="form-group">
                <validation-provider
                  name="zipcode"
                  rules="required|numeric"
                  v-slot="{ errors }"
                >
                  <label for="company-zipcode"
                    >{{ $t('form.zipcode') }}
                    <sup class="text-danger">*</sup></label
                  >
                  <input
                    v-model="zipCode"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    id="company-zipcode"
                    :placeholder="$t('form.zipcode')"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider
                  name="city"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="company-city"
                    >{{ $t('form.city') }}
                    <sup class="text-danger">*</sup></label
                  >
                  <input
                    v-model="city"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    id="company-city"
                    :placeholder="$t('form.city')"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between mt-3">
            <button
              type="submit"
              class="btn btn-outline-secondary"
              @click.stop.prevent="resetForm"
            >
              {{ $t('buttons.cancelButton') }}
            </button>
            <div v-if="monitor.visible" :class="monitor.type">
              {{ monitor.message }}
            </div>
            <button
              type="submit"
              class="btn btn-primary"
              @click.stop.prevent="save"
            >
              {{ $t('buttons.save') }}
            </button>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <div v-else class="h-100">
      <div class="h-100 row d-flex justify-content-center align-items-center">
        <div class="col-12">
          <div class="d-flex justify-content-center align-items-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Chargement...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import getCodeNaf from '@/js/code-naf.js'
import AdvancedSearch from 'vue-advanced-search'
import { mapFields } from 'vuex-map-fields'
import { validate, extend, ErrorBag } from 'vee-validate'
import * as i18nIsoCountries from 'i18n-iso-countries'
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/fr.json'))
i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/en.json'))
import Swal from 'sweetalert2'
import { mask } from 'vue-the-mask'
export default {
  name: 'CompanyInformations',
  props: [],
  components: { AdvancedSearch, Treeselect },
  data() {
    return {
      firstname: '',
      lastname: '',
      email: null,
      name: '',
      legalForm: '',
      vat: null,
      phone: '',
      country: '',
      trade: '',
      address: '',
      city: '',
      siret: '',
      zipCode: '',
      countries: [],
      options: [],
      nafCode: '',
      nafLabel: '',
      isLoaded: false,
      locale: '',
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields(['user', 'apiKeyINSEE']),
  },
  created() {
    this.locale = document.head.querySelector('meta[name="app-locale"]').content
    let INSEEApiKey = document.head.querySelector('meta[name="insee-api-key"]')
    this.$store.commit('SET_API_KEY_INSEE', INSEEApiKey.content)
    let countries = i18nIsoCountries.getNames(this.locale, {
      select: 'official',
    })
    this.countries = Object.entries(countries).map(([key, value]) => ({
      id: key,
      name: value,
    }))
  },
  mounted() {
    setTimeout(() => {
      let user = this.$store.state.user
      console.log(user)
      this.reset(user)
      this.populate(user)
    }, 1500)
    this.options = getCodeNaf().options
  },
  methods: {
    setCodeNAf(value) {
      this.nafLabel = value.label
    },
    validationObeserverValidate() {
      if (this.country == 'France') {
        this.name = null
      }
    },
    handleCompanySIRET(event) {
      let customSwal = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
      let siret = event.target.value
      if (siret.length > 1) {
        validate(siret, 'digits:14')
          .then((result) => {
            const { valid, errors } = result
            if (!valid) {
              return Promise.reject(this.$t('validationSiret'))
            }
            return this.$store
              .dispatch('validateCompanySiret', siret)
              .then((response) => {
                if (this.$lodash.get(response, 'data.etablissement.siret')) {
                  let etablissement = response.data.etablissement
                  let uniteLegale = etablissement.uniteLegale
                  this.name = uniteLegale.denominationUniteLegale
                } else {
                  this.name = ''
                }
              })
              .catch((error) => {
                this.name = ''
                return Promise.reject(
                  // `Votre SIRET ${siret} n'est pas connu de la base INSEE`
                  this.$t('errors.siret', { siret: siret })
                )
              })
          })
          .catch((error) => {
            this.name = ''
            this.$refs.mysiret.applyResult({
              errors: [error], // array of string errors
              valid: false, // boolean state
              failedRules: {}, // should be empty since this is a manual error.
            })
            customSwal.fire({
              title: this.$t('validationSiretMessage'),
              text: error,
            })
          })
      }
    },
    resetForm() {
      let user = this.$store.state.user
      this.populate(user)
    },
    validate(next) {
      this.$refs.observer.validate().then((valid) => {
        if (!valid) {
          this.monitor.type = 'text-danger'
          this.monitor.message = this.$t('errors.requiredFields')
          this.monitor.visible = true
          setTimeout(() => {
            this.monitorHide()
          }, 1500)
        } else {
          next()
        }
      })
    },
    save() {
      this.validate(this.update)
    },
    update() {
      let params = {}
      if (this.firstname) {
        params.firstname = this.firstname
      }
      if (this.lastname) {
        params.lastname = this.lastname
      }
      params.email = this.email
      params.phone = this.phone
      params.address = this.address
      params.country = this.country.name
      params.country_code = this.country.id
      params.city = this.city
      params.zipcode = this.zipCode
      params.name = this.name
      params.legal_form = this.legalForm
      params.trade_name = this.trade
      params.siret = this.siret
      params.vat = this.vat
      params.naf_code = this.nafCode
      params.naf_name = this.nafLabel
      this.$store
        .dispatch('updateUserInformation', params)
        .then(() => {
          this.monitor.type = 'text-success'
          this.monitor.message = this.$t('updateInformations')
          this.monitor.visible = true
          this.$store.dispatch('getAccountInformations')
          setTimeout(() => {
            this.monitorHide()
          }, 1500)
        })
        .catch((error) => {
          this.monitor.type = 'text-warning'
          this.monitor.message = this.$t('errors.serverError')
          this.monitor.visible = true
          console.log(error)
          setTimeout(() => {
            this.monitorHide()
          }, 1500)
        })
    },
    populate(data) {
      if (data.firstname) {
        this.firstname = data.firstname
      }
      if (data.lastname) {
        this.lastname = data.lastname
      }
      if (data.name) {
        this.name = data.name
      }
      // if (data.tradeName) {
      //   this.trade = data.tradeName
      // }
      if (data.siret) {
        this.siret = data.siret
      }
      if (data.legalForm) {
        this.legalForm = data.legalForm
      }
      if (data.address) {
        this.address = data.address
      }
      if (data.zipcode) {
        this.zipCode = data.zipcode
      }
      if (data.city) {
        this.city = data.city
      }
      if (data.country) {
        this.country = { name: data.country, id: data.countryCode }
      }
      if (data.phone) {
        this.phone = data.phone
      }
      if (data.email) {
        this.email = data.email
      }
      if (data.vat) {
        this.vat = data.vat
      }
      if (data.NAFCode) {
        this.nafCode = data.NAFCode
      }
      if (data.NAFName) {
        this.nafLabel = data.NAFName
      }
      this.isLoaded = true
    },
    reset(data) {
      this.firstname = null
      this.lastname = null
      this.email = null
      this.phone = null
      this.email = null
      this.phone = null
      this.address = null
      this.country = null
      this.countryCode = null
      this.city = null
      this.zipcode = null
      this.name = null
      this.legalForm = null
      this.trade = null
      this.siret = null
      this.vat = null
      this.nafCode = null
      this.nafName = null
    },
    monitorHide() {
      this.monitor.type = ''
      this.monitor.message = ''
      this.monitor.visible = false
    },
  },
}
</script>

<style></style>
